const PageLabel = () => import('@/modules/message/label/PageLabel')

export default [
  {

    path: '/label',
    name: 'label',
    component: PageLabel,
    meta: {
      title: '标签管理',
      isBlack: true
    },
  },
]
